import React, { useContext, useEffect, useState } from 'react';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import { ProfileContext } from '../../../../services/profile/profile.context';
import useIslogin from '../../../../components/Hook/useIslogin';
import { MeetingPreload } from '../meeting-preload';
import { MeetingsContext } from '../../../../services/meetings/meetings.context';
import moment from 'moment';
import { MeetingsCard } from '../meetings/meetings-card';
import { urlConfig } from '../../../../config/urlConfig';
import useFetch from '../../../../services/global/useFetch';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      width: '30%',
    },
  };
});

export const InProgressContainer = () => {
  const classes = useStyles();
  const { user } = useContext(ProfileContext);
  const { setPublicMeeting } = useContext(MeetingsContext);
  const [meetings, setMeetings] = useState(null);

  const {
    data,
    isPending: isLoading,
    error,
  } = useFetch(urlConfig.meeting_in_progress_url);

  const checkIsHostExist = (members, user) => {
    let checker = false;

    members.map((item) => {
      if (item.member_uuid && item.member_uuid === user.uid) {
        checker = true;
      }
    });

    return checker;
  };

  const addMeeting = (meeting, user) => {
    let inProgress = [];
    let publicMeet = [];

    meeting &&
      meeting.map((item) => {
        if (item.is_public === false) {
          inProgress.push(item);
        } else if (item.is_public === true) {
          publicMeet.push(item);
          if (
            item.members &&
            item.members.length > 0 &&
            checkIsHostExist(item.members, user)
          ) {
            inProgress.push(item);
          }
        }
      });

    publicMeet.length > 0 && setPublicMeeting([...publicMeet]);
    inProgress.length > 0 && setMeetings([...inProgress]);
  };

  useIslogin();

  useEffect(() => {
    data && user && addMeeting(data, user);
  }, [data, user]);

  return (
    <>
      {error && (
        <Typography variant='h6' color='primary'>
          {error}
        </Typography>
      )}
      {isLoading ? (
        <MeetingPreload />
      ) : (
        <Grid container justifyContent='flex-start' spacing={2}>
          {meetings &&
            meetings.length > 0 &&
            user &&
            meetings.map((meeting, index) => (
              <Grid
                key={index}
                item
                xs={12}
                sm={6}
                md={4}
                lg={4}
                className={classes.root}
              >
                <MeetingsCard meeting={meeting} user={user} inProgress />
              </Grid>
            ))}
        </Grid>
      )}
    </>
  );
};
